import { Box } from "@mui/material";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
const countries = { en: "gb", cn: "cn", ru: "ru", es: "es", sa: "sa", pt: "pt" };
export default function LanguageLabel({ code, children }) {
  const country = countries[code];
  return <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 1, minWidth: 0 }}>
    {country ? <Box component="img" src={`/flags/${country}.png`} alt="" data-language={code}
      sx={{ width: 20, height: 14, objectFit: "cover", borderRadius: "2px", flexShrink: 0 }} />
      : <PublicOutlinedIcon sx={{ fontSize: 18, flexShrink: 0 }} />}
    <span>{children}</span>
  </Box>;
}
